module.exports = __webpack_public_path__ + "static/img/banner_2.db1c2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_2.jpg
// module id = /G0a
// module chunks = 1